import { FunctionComponent, useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useFetchShouldPromptForReview } from '@hooks';
import { useSessionExpiredCheck } from '@hooks/auth';
import styled from 'styled-components';
import { StyledElement } from '@components/ui/types';

const BaseContainer = styled.div`
  padding-top: 6rem;
  @media (max-width: 992px) {
    padding-top: 2rem;
  }

  @media (max-width: 488px) {
    padding: 2rem 1rem 0 1rem;
  }
`;

const BaseLayout: FunctionComponent<StyledElement> = ({
  children,
  className,
}) => {
  useSessionExpiredCheck();
  useFetchShouldPromptForReview();
  const router = useRouter();
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    const routeChangeComplete = (url: string) => {
      const splitUrl = url.split('/');

      const formattedUrl = splitUrl.map(
        (path) => path.charAt(0).toUpperCase() + path.slice(1),
      );

      setPageTitle(formattedUrl.join(' ').split('?')[0]);
    };

    router.events.on('routeChangeComplete', routeChangeComplete);

    return () => {
      router.events.off('routeChangeComplete', routeChangeComplete);
    };
  }, [router.events]);

  useEffect(() => {
    if (typeof window !== 'undefined' && pageTitle !== '') {
      const _hsq = (window._hsq = window._hsq || []);
      _hsq.push(['setPath', router.asPath]);
      _hsq.push(['trackPageView']);
    }
  }, [pageTitle, router.asPath]);

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <BaseContainer className={className}>{children}</BaseContainer>
    </>
  );
};

export default BaseLayout;
